import { NewsletterState } from "./reducer"

export const getNewsletterSubscribed = (state: { newsletter: NewsletterState }) =>
  state.newsletter.subscribed
